export const TranslateConstant = {
    REGIST_TRANSLATE_DATA: 'REGIST_TRANSLATE_DATA',
    MODIFY_TRANSLATE_DATA: 'MODIFY_TRANSLATE_DATA',
    DELETE_TRANSLATE_DATA: 'MODIFY_TRANSLATE_DATA',
    GET_TRANSLATE_DATA: 'GET_TRANSLATE_DATA',
    SEARCH_TRANSLATE_DATA: 'SEARCH_TRANSLATE_DATA'
};